












import emojis from './emojis';
import Vue from 'vue';

export default Vue.extend({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    top: {
      type: Number,
      default: 0,
    },
    left: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    selectEmoji(emoji: object) {
      this.$emit('selected', emoji);
    },
    transImg(img: string) {
      return require('assets/img/common/emoji/' + img + '.png');
    },
  },
  data() {
    return {
      emojis,
    };
  },
  mounted() {
    window.document.body.addEventListener('click', () => {
      this.$emit('updateShow', false);
    });
  },
});
